import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService, GrowlType } from '../../../infrastructure/services/alert.service';
import { SxHttpService } from '../../../infrastructure/services/sxHttp.service';
import { File64 } from '../../../helpers/components/sxFileImport/file64.interf';
import { AzureFileManagerService } from 'app/infrastructure/services/azureFileManager.service';
import { AzureFile } from 'app/infrastructure/model/interfaces/azureFile.Interface';

@Component({
    templateUrl: 'import.output.component.html'
})
export class ImportOutputComponent implements OnInit {
    public search: string;

    systemCode: string;
    outputCode: string;
    preguntarSiDeseaBorrar = [];
    azureFiles: AzureFile[] = [];
    supported: string[] = ['.xlsx'];

    file: File64 = null;

    constructor(private aRoute: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private sxHttp: SxHttpService,
        //private location: Location,
        private fileManagerService: AzureFileManagerService) { }

    ngOnInit() {
        this.aRoute.params.subscribe(params => {
            this.systemCode = params['codsistema'];
            this.outputCode = params['codoutput'];
            this.getFiles();
        });
    }

    uploadFile() {
        if (!this.file) {
            this.alertService.showGrowl({
                type: GrowlType.DANGER,
                body: 'SOC_FE_0002_MUST_SELECT_A_FILE'
            });

            return;
        }

        if (!this.isExcelFile(this.file.fileName)) {
            this.alertService.showGrowl({
                type: GrowlType.DANGER,
                body: 'SOC_FE_0006_FILE_MUST_BE_XLSX'
            });

            return;
        }

        let fileToUpload: any;

        fileToUpload = {
            systemCode: this.systemCode,
            fileName: this.file.fileName,
            folder: this.outputCode,
            file: this.file.fileData
        };

        this.fileManagerService.uploadOutputFile(fileToUpload).then(response => {
            this.file = null;
            this.getFiles();
        });
    }

    getFiles() {
        this.azureFiles = [];
        this.fileManagerService.getOutputFiles(this.systemCode, this.outputCode).subscribe(files => {
            this.azureFiles = files;
        });
    }

    selectedFile(imp: File64) {
        this.file = imp;
    }

    isExcelFile(fileName: string): boolean {
        if (fileName.split('.').pop().replace(/^/, '.') === '.xlsx') {
            return true;
        }
        return false;
    }
    isNotAvailable(value: boolean) {
        if (value)
            this.file = null;
    }
    /*goBack() {
        this.location.back();
    }*/

    disableSave() {
        let disable = false;

        if (this.azureFiles.length === 0) {
            disable = this.file === null;
        } else {
            disable = true;
        }

        return disable;
    }

    disableScan() {
        return this.azureFiles.length === 0;
    }

    gotToScan() {
        this.router.navigate(['../mapping'], { relativeTo: this.aRoute });
    }

    deletFile(file: AzureFile) {
        this.fileManagerService.deleteOutputFile(this.systemCode, this.outputCode, file).subscribe(
            result => {
                let type = GrowlType.SUCCESS;
                let body = 'FILE_DELETED';

                if (!result) {
                    type = GrowlType.DANGER;
                    body = 'SOC_FE_0007_FILE_COULD_NOT_BE_DELETED';
                } else {
                    this.getFiles();
                }

                return this.alertService.showGrowl({
                    type: type,
                    body: body,
                });
            });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/outputs/import/import.output.component.ts